import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';
import { UiCInputModule } from '@wlp/ui-c-input';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCRetryRegistrationComponent = class UiCRetryRegistrationComponent {
    constructor() {
        this.isBack = true;
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.checkDocument = new EventEmitter();
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit();
    }
    onDocumentBlur(data) {
        this.checkDocument.emit(data);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCRetryRegistrationComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCRetryRegistrationComponent.prototype, "form", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRetryRegistrationComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCRetryRegistrationComponent.prototype, "block", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRetryRegistrationComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRetryRegistrationComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRetryRegistrationComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRetryRegistrationComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCRetryRegistrationComponent.prototype, "documentInvalid", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRetryRegistrationComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRetryRegistrationComponent.prototype, "continue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRetryRegistrationComponent.prototype, "checkDocument", void 0);
UiCRetryRegistrationComponent = __decorate([
    Component({
        selector: 'ui-c-retry-registration',
        template: "<div class=\"animation-type\">\n\n  <ui-c-header-onboarding [isBack]=\"isBack\" [textBack]=\"'RETRY_ONBOARDING.BUTTONS.BACK' | wlpTranslate\" [title]=\"title\"\n    [description]=\"description\" [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" (back)=\"goBack()\">\n  </ui-c-header-onboarding>\n\n  <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input (keyup)=\"onDocumentBlur($event)\" [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'document'\"\n        [placeholder]=\"'RETRY_ONBOARDING.FORM.DOCUMENT.PLACEHOLDER' | wlpTranslate\" [maxlength]=\"18\"\n        [name]=\"'RETRY_ONBOARDING.FORM.DOCUMENT.LABEL' | wlpTranslate\" [isPerson]=\"true\">\n      </ui-c-input>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\"\n      [ngClass]=\"form.get('document').invalid || !documentInvalid ? 'disabled' : ''\">\n      <ui-c-button expand=\"block\" (click)=\"goContinue()\">\n        {{ 'RETRY_ONBOARDING.BUTTONS.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>"
    })
], UiCRetryRegistrationComponent);

let UiCRetryRegistrationModule = class UiCRetryRegistrationModule {
};
UiCRetryRegistrationModule = __decorate([
    NgModule({
        declarations: [UiCRetryRegistrationComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCInputModule,
            UiCHeaderOnboardingModule
        ],
        exports: [UiCRetryRegistrationComponent]
    })
], UiCRetryRegistrationModule);

export { UiCRetryRegistrationComponent, UiCRetryRegistrationModule };
//# sourceMappingURL=wlp-ui-c-retry-registration.js.map
